import React from "react";
import DataTable from "react-data-table-component";

const TreeFellItemsTable = (props) => {
  const treeFellItemsColumns = [
    {
      name: "Species",
      selector: (row) => props.speciesOptions?.optionFor(row)?.label || "—",
    },
    {
      name: "Description",
      selector: (row) => row.description,
    },
   
    {
      name: "Quantity",
      selector: (row) => row.quantity,
    },
    {
      name: "Diameters (cm)",
      selector: (row) => row.dimension,
    },
    {
      name: "Length (cm)",
      selector: (row) => row.length,
    },
    {
      name: "Width (cm)",
      selector: (row) => row.width,
    },
    {
      name: "Volume",
      selector: (row) => row.volume,
    },
    // {
    //   name: "Actions",
    //   selector: (row) => (
    //     <div>
    //       <button
    //       className="px-2 py-1 text-gray-500 hover:bg-red-700 hover:text-white"
    //       onClick={()=>props.deleteAction(row.userInfo.userId)}
    //     >
    //       <FiTrash />
    //     </button>
    //     </div>
    //   ),
    // },
  ];
  return (
    <div className="w-full">
      <DataTable
        className="w-full rounded rounded-lg"
        columns={treeFellItemsColumns}
        data={props.treeFellItems}
        pagination
      />
    </div>
  );
};

export default TreeFellItemsTable;
